var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-4717975078b535c790596dd75dea4ddc.svg#icon-default-author-2537d';
                    var viewUrl = 'svg-sprite-4717975078b535c790596dd75dea4ddc.svg#view-icon-default-author-2537d';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: 'undefined',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };